import Store                from "Dashboard/Core/Store";
import DateTime             from "Dashboard/Utils/DateTime";
import Utils                from "Dashboard/Utils/Utils";
import { Member }           from "Utils/API";



// The initial State
const initialState = {
    loading    : false,
    error      : false,
    edition    : 0,
    canCreate  : false,
    canEdit    : false,
    canFilter  : false,
    canImport  : false,
    canExport  : false,
    list       : [],
    total      : 0,
    elem       : {},
    categories : [],
    states     : [],
    filters    : {},
    hasFilters : false,
    sort       : {
        orderBy  : "memberNumber",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "MEMBER_LOADING" });
    },

    /**
     * Fetches the Member List
     * @param {Function} dispatch
     * @param {Object=}  filters
     * @param {Object=}  sort
     * @returns {Promise}
     */
    async fetchList(dispatch, filters = {}, sort = {}) {
        const data   = await Member.getAll({ ...filters, ...sort });
        data.filters = filters;
        data.sort    = sort;
        dispatch({ type : "MEMBER_LIST", data });
    },

    /**
     * Fetches a single Member Element
     * @param {Function} dispatch
     * @param {Number}   memberNumber
     * @returns {Promise}
     */
    async fetchElem(dispatch, memberNumber) {
        const data = await Member.getOne({ memberNumber });
        dispatch({ type : "MEMBER_ELEM", data });
    },

    /**
     * Fetches the Member Filter data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchFilterData(dispatch) {
        const data = await Member.getFilterData();
        dispatch({ type : "MEMBER_FILTER", data });
    },

    /**
     * Register the Member
     * @param {Function} dispatch
     * @param {Number}   memberNumber
     * @returns {Promise}
     */
    registerElem(dispatch, memberNumber) {
        return Member.register({ memberNumber });
    },

    /**
     * Unregister the Member
     * @param {Function} dispatch
     * @param {Number}   memberNumber
     * @returns {Promise}
     */
    unregisterElem(dispatch, memberNumber) {
        return Member.unregister({ memberNumber });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.fullName           = `${elem.memberNumber} - ${elem.firstName} ${elem.lastName}`;
    elem.isRegisteredText   = Utils.toYesNo(elem.isRegistered);
    elem.isRegisteredClass  = elem.isRegistered ? "text-green" : "text-red";
    elem.registeredTimeText = DateTime.formatString(elem.registeredTime, false);
    elem.modifiedTimeText   = DateTime.formatString(elem.modifiedTime, false);
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "MEMBER_LIST", "MEMBER_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "MEMBER_LOADING":
        return {
            ...state,
            loading    : true,
        };

    case "MEMBER_LIST":
        return {
            ...state,
            loading    : false,
            error      : false,
            canCreate  : action.data.canCreate,
            canEdit    : action.data.canEdit,
            canFilter  : action.data.canFilter,
            canImport  : action.data.canImport,
            canExport  : action.data.canExport,
            list       : Utils.parseList(action.data.list, parseElem),
            total      : action.data.total,
            filters    : action.data.filters,
            hasFilters : !Utils.isEmpty(action.data.filters),
            sort       : action.data.sort,
        };

    case "MEMBER_ELEM":
        return {
            ...state,
            error      : false,
            edition    : state.edition + 1,
            elem       : parseElem(action.data.elem),
        };

    case "MEMBER_FILTER":
        return {
            ...state,
            error      : false,
            edition    : state.edition + 1,
            categories : action.data.categories,
            states     : action.data.states,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
